import type { FaqItem } from "../types/landing";
export const faqItems: FaqItem[] = [
  {
    id: "cero",
    question: "¿Puedo empezar desde cero?",
    answer: "Sí. El Tomo 1, Japonés desde cero, empieza por hiragana, katakana y primeros pasos. Está pensado para quienes no tienen conocimientos previos.",
  },
  {
    id: "espanol",
    question: "¿Las explicaciones están en español?",
    answer: "Sí. Todas las explicaciones están en español, para que puedas concentrarte en el japonés y no en traducir la teoría.",
  },
  {
    id: "niveles",
    question: "¿Qué niveles se trabajan?",
    answer: "Contenidos progresivos de N5 y N4. Los primeros cuatro tomos recorren los inicios y el N5; del Tomo 5 al 7 avanzás hacia el N4.",
  },
  {
    id: "diferencia",
    question: "¿Qué diferencia hay entre Base, Pro y Completo?",
    answer: "Base incluye los 7 tomos principales (7 ebooks). Pro suma los 5 bonos de kanji (12 ebooks). Completo agrega Japonés práctico para viajes y el diccionario de 5.000 palabras (14 ebooks).",
  },
  {
    id: "bonos-base",
    question: "¿Los bonos están incluidos en el Base?",
    answer: "No. Los cinco bonos de kanji están incluidos en Pro y Completo. El Base incluye los siete tomos principales, que forman por sí solos el recorrido de estudio de cero a N4.",
  },
  {
    id: "completo-pro",
    question: "¿Qué agrega el Completo al Pro?",
    answer: "Dos recursos de aplicación y consulta: Japonés práctico para viajes y el Diccionario práctico japonés–español de 5.000 palabras. Ambos forman parte del precio del Completo.",
  },
  {
    id: "diccionario",
    question: "¿El diccionario corresponde solamente a N4?",
    answer: "No. Es un recurso ampliado de vocabulario de uso frecuente y utilidad cotidiana. Su alcance puede superar el vocabulario trabajado en los siete tomos.",
  },
  {
    id: "formato",
    question: "¿Son libros físicos o archivos digitales?",
    answer: "Son ebooks en PDF. Los libros que ves en las imágenes son representaciones visuales del material.",
  },
  {
    id: "imprimir",
    question: "¿Necesito imprimirlos?",
    answer: "No. Podés estudiarlos en pantalla. Si te resulta más cómodo trabajar en papel, podés imprimir las partes que quieras para tu uso personal.",
  },
  {
    id: "clases",
    question: "¿Incluye clases, audios o videos?",
    answer: "No. El megapack está compuesto por ebooks en PDF. No incluye clases, audios ni videos.",
  },
  {
    id: "jlpt",
    question: "¿Garantiza aprobar el JLPT?",
    answer: "No. Es material de estudio con contenidos de N5 y N4. No garantiza aprobar el JLPT, no otorga certificación oficial y no reemplaza la conversación ni la exposición al idioma.",
  },
  {
    id: "entrega",
    question: "¿Cómo recibo mi compra?",
    answer: "",
    configKey: "delivery",
  },
  {
    id: "devolucion",
    question: "¿Cuál es la política de devolución?",
    answer: "",
    configKey: "refund",
  },
];
